import { Component } from '@verndale/core';

class Module extends Component {
  setupDefaults() {
    this.dom = {
      nextBtn: this.el.querySelector('.arrow-btn__next'),
      prevBtn: this.el.querySelector('.arrow-btn__prev'),
      cards: this.el.querySelectorAll('.featured-events__event'),
      sliderWrapper: this.el.querySelector('.featured-events__slider'),
      sliderContainer: this.el.querySelector('.featured-events__slider-container'),
      controlsContainer: this.el.querySelector('.featured-events__controls')
    };
    this.currentSlide = 0;
    this.gap = 40;
    this.mq = window.matchMedia('(max-width: 1024px)');
    this.animationDone = true;
    this.time = 0.5;
    this.timeoutTime = this.time * 1000;
    this.initSlider();
  }

  addListeners() {
    this.dom.nextBtn.addEventListener('click', () => {
      if (this.animationDone) {
        this.animationDone = false;
        this.nextSlide();
      }
    });

    this.dom.prevBtn.addEventListener('click', () => {
      if (this.animationDone) {
        this.animationDone = false;
        this.prevSlide();
      }
    });

    window.addEventListener('resize', () => {
      if (this.mq.matches) {
        this.dom.cards.forEach(card => {
          const innerCard = card.querySelector('.featured-events__event-inner-container');
          innerCard.style.width = '';
        });
        this.dom.sliderContainer.style.blockSize = '';
        this.initSlider();
      } else {
        this.initSlider();
        this.dom.sliderContainer.removeAttribute('style');
        this.dom.sliderWrapper.removeAttribute('style');
        this.dom.cards.forEach(card => {
          const innerCard = card.querySelector('.featured-events__event-inner-container');
          innerCard.style.width = `${this.activeCard.offsetWidth}px`;
          card.style.width = '';
        });
      }
    });

    this.dom.cards.forEach((card, index) => {
      card.addEventListener('click', () => {
        this.currentSlide = index;
        this.updateCarousel();
      });
    });

    //   add touch events for mobile
    let xDown = null,
      yDown = null;

    this.dom.sliderWrapper.addEventListener('touchstart', e => {
      const firstTouch = e.touches[0];
      xDown = firstTouch.clientX;
      yDown = firstTouch.clientY;
    }, false);

    this.dom.sliderWrapper.addEventListener('touchmove', e => {
      if (!xDown || !yDown) {
        return;
      }

      const xUp = e.touches[0].clientX;
      const yUp = e.touches[0].clientY;

      const xDiff = xDown - xUp;
      const yDiff = yDown - yUp;

      if (Math.abs(xDiff) > Math.abs(yDiff)) {
        if (xDiff > 0) {
          this.nextSlide();
        } else {
          this.prevSlide();
        }
      }

      xDown = null;
      yDown = null;
    }, false);
  }

  initSlider() {
    if (this.mq.matches) {
      this.dom.sliderContainer.style.blockSize = `${this.dom.sliderWrapper.offsetHeight}px`;
      this.dom.sliderWrapper.style.blockSize = '100%';
      this.dom.sliderWrapper.style.width = '';
    } else {
      this.setActiveState();
    }
  }

  setActiveState() {
    this.dom.cards.forEach(card => {
      card.classList.remove('active');
      card.style.width = '';
    });

    this.activeCard = this.dom.cards[this.currentSlide];
    this.activeCard.classList.add('active');


    setTimeout(() => {
      this.dom.cards.forEach(card => {
        const innerCard = card.querySelector('.featured-events__event-inner-container');
        innerCard.style.width = `${this.activeCard.offsetWidth}px`;
        this.animationDone = true;

      });
    }, this.timeoutTime);
  }

  updateCarousel() {
    if (this.mq.matches) {
      const offset = -this.currentSlide * 100;
      const currentGap = this.currentSlide * this.gap;
      this.dom.sliderWrapper.style.transform = `translateX(calc(${offset}% - ${currentGap}px))`;
      this.animationDone = true;
    } else {
      this.setActiveState();
    }
  }


  nextSlide() {
    this.dom.nextBtn.disabled = this.currentSlide + 1 === this.dom.cards.length - 1;
    this.dom.prevBtn.disabled = false;
    if (this.currentSlide === this.dom.cards.length - 1) return;
    this.currentSlide++;
    this.updateCarousel();

  }

  prevSlide() {
    this.dom.prevBtn.disabled = this.currentSlide - 1 === 0;
    this.dom.nextBtn.disabled = false;
    if (this.currentSlide === 0) return;
    this.currentSlide--;
    this.updateCarousel();

  }

}

export default Module;
